export default __webpack_public_path__ + "static/cleaning_gloves-bc219744c887abb90356e43f6489b635.jpg";